import { AudioSoundEvent, Exercise, Phase, ScheduleEntryColourCode, SessionSequence } from '../../../entities';
import { ISessionSequenceStrategy } from '../isessionsequencestrategy';
import { transitionBeepAudioTipFileName } from './homeSharedSequenceEntries';

export class HomeWarmdown implements ISessionSequenceStrategy {
  public getSessionSequence(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
  ): SessionSequence[] {
    return [{
      durationInMilliseconds: 121,
      sequence: [{
        durationInMilliseconds: 121,
        videoFile: exercise.uniqueReferenceNumber,
        exerciseVersion: exercise._rev,
        displayName: exercise.name,
        displayBurnOrBuildIcon: true,
        progressColourCode: ScheduleEntryColourCode.Play,
        progressText: 'Cool down for {seconds}',
        showProcessedMetrics: true,
        showCalculatedMetrics: true,
        audioSoundEvent: AudioSoundEvent.startOfWorkout,
        tips: Exercise.getFormattedTips(exercise),
        audioTipStartDelay: 0,
        audioTipFileName: transitionBeepAudioTipFileName,
        audioTips: [{
          fileName: transitionBeepAudioTipFileName, delay: 0,
        }],
        phase: Phase.Train,
        zone,
        showParticipantsInsteadOfTipsInGroupWorkout: true,
        videoHasAudio: true,
        playVideoFromCurrentSequenceDuration: true,
      }],
    }, {
      durationInMilliseconds: 20,
      sequence: [{
        durationInMilliseconds: 20,
        videoFile: SessionSequence.postWarmdownVideoName(),
        exerciseVersion: exercise._rev,
        displayName: exercise.name,
        displayBurnOrBuildIcon: false,
        progressColourCode: ScheduleEntryColourCode.Rest,
        progressText: 'Well done!',
        showProcessedMetrics: true,
        showCalculatedMetrics: true,
        audioSoundEvent: AudioSoundEvent.endOfWorkoutSession,
        tips: Exercise.getFormattedTips(exercise),
        audioTipStartDelay: 1000,
        phase: Phase.ChangeZone,
        zone,
        showLargeViewInGroupWorkout: true,
      }],
    }];
  }
}
